import ButtonBox from "../../Common/ButtonBox";
import { ArrowRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Contexts/GlobalContext";
import { useNavigation } from "../../../Contexts/navigationContext";
import { redirectToDashboardWithCorrectCourseHighlighted } from "../../../Utilities/ReRoutingUtils";

const ContentActionButton = () => {
    const navigate = useNavigate();
    const { scrollToCurriculum } = useNavigation();
    const { loggedIn } = useGlobalContext();
    const location = useLocation();
    const url = location.pathname;

    const handlePrimaryClick = () => {
        if (loggedIn) redirectToDashboardWithCorrectCourseHighlighted(url);
        else navigate("/signup");
    };

    return (
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
            <ButtonBox
                backgroundColor="#FFFFFF"
                className="text-[#3940A0] py-3 px-7 w-[252px] h-12 sm:w-auto sm:h-auto text-center font-gilroy-bold font-normal cursor-pointer flex items-center justify-center gap-1 shadow-[0px_14px_4px_-4px_rgba(0,0,0,0.25),inset_0px_0.62px_1.11px_#FFFFFF,inset_0px_-1.24px_0px_#000000]"
                borderColor=""
                borderRadius="12px"
                borderWidth=""
                onClick={handlePrimaryClick}
            >
                {loggedIn ? "Start Learning" : "Start 7-Days Free Trial"}
                <ArrowRight size={20} />
            </ButtonBox>

            <ButtonBox
                backgroundColor="transparent"
                className="text-[#F2F4FC] py-3 px-7 w-[252px] h-12 sm:w-[252px] sm:h-auto text-center font-gilroy-bold cursor-pointer"
                borderColor="#F2F4FC"
                borderRadius="12px"
                borderWidth="1px"
                onClick={scrollToCurriculum}
            >
                View Curriculum
            </ButtonBox>
        </div>
    );
};

export default ContentActionButton;
